/** Shown where a value is missing or not applicable. */
export const EMPTY_VALUE = '—';

/** Shown while a value is still loading. */
export const LOADING_VALUE = '…';
